export const SET_ONBOARDING_STEPS = "set_onboarding_steps";
export const SET_CURRENT_ONBOARDING_STEP = "set_current_onboarding_step";
export const ONBOARDING_AUTO_COMPLETE = "onboarding_auto_complete";
export const ONBOARDING_LOADING_SUCCESS = "onboarding_loading_success";
export const SET_ONBOARDING_LAYOUT = "set_onboarding_layout";
export const SET_ROUTE_FOR_ONBOARDING = "set_route_for_onboarding";
